// Constants + default form shape shared by the Deals page and all of its
// extracted subcomponents. Kept in plain JS (no JSX) so it can be imported
// from any subcomponent without React overhead.

export const STATUS_COLORS = {
  interested: "bg-emerald-50 text-emerald-700 border-emerald-200",
  committed:  "bg-indigo-50 text-indigo-700 border-indigo-200",
  pass:       "bg-rose-50 text-rose-700 border-rose-200",
  need_info:  "bg-amber-50 text-amber-700 border-amber-200",
};

export const STATUS_LABELS = {
  interested: "Interested",
  committed:  "Committed",
  pass:       "Pass",
  need_info:  "Needs Info",
};

// Authoritative US commercial property type list — covers >95% of CRE deals
// landlords pitch to investors. "Other" is the safety hatch.
export const PROPERTY_TYPES = [
  { value: "office",         label: "Office" },
  { value: "retail",         label: "Retail" },
  { value: "industrial",     label: "Industrial / Flex" },
  { value: "multifamily",    label: "Multifamily" },
  { value: "mixed_use",      label: "Mixed-Use" },
  { value: "hospitality",    label: "Hospitality / Hotel" },
  { value: "self_storage",   label: "Self Storage" },
  { value: "medical_office", label: "Medical Office" },
  { value: "senior_living",  label: "Senior Living" },
  { value: "student_housing",label: "Student Housing" },
  { value: "land",           label: "Land / Development" },
  { value: "other",          label: "Other" },
];

export function defaultForm() {
  return {
    name: "", address: "", property_type: "office",
    sqft: "", units: "", year_built: "",
    lat: null, lng: null, formatted_address: null, place_id: null,
    address_verified: false,
    // Transaction
    transaction_type: "purchase",  // purchase | refinance
    purchase_date: "",             // ISO YYYY-MM-DD (HTML date input)
    existing_liens: "",
    as_is_value: "",
    arv_value: "",
    tax_value: "",
    improvements: "",
    purchase_price: "", noi: "", cap_rate: "", projected_irr: "",
    equity_required: "", hold_period_years: "", minimum_investment: "",
    loan_amount: "", ltv: "", interest_rate: "", amortization_years: "",
    loan_type: "amortizing",
    loan_notes: "",
    sponsor_name: "", sponsor_track_record: "", executive_summary: "",
    target_close_date: "",
  };
}
